import React from 'react';

interface TitleWithLanternsProps {
  title: string;
  subtitle?: string;
  lanternType: 1 | 2 | 3 | 4;
  className?: string;
  titleClassName?: string;
}

const TitleWithLanterns: React.FC<TitleWithLanternsProps> = ({ 
  title, 
  subtitle, 
  lanternType,
  className = "",
  titleClassName = "text-display-lg md:text-display-xl font-display text-white text-shadow-luxury"
}) => {
  const lanternSrc = `/restaurant_photos/lantern_${lanternType}.png`;
  
  return (
    <div className={`relative z-10 text-center ${className}`}>
      <div className="relative inline-block">
        {/* Left Lantern */}
        <img 
          src={lanternSrc}
          alt=""
          className="absolute -left-20 md:-left-24 lg:-left-28 top-1/2 -translate-y-1/2 w-16 h-20 md:w-20 md:h-24 lg:w-24 lg:h-28 object-contain"
        />
        
        {/* Content */}
        <div>
          {subtitle && (
            <p className="text-luxury-champagne text-lg tracking-luxury uppercase font-body mb-4">
              {subtitle}
            </p>
          )}
          <h1 className={titleClassName}>
            {title}
          </h1>
          <div className="h-px bg-luxury-gold mx-auto mt-6 w-20" />
        </div>
        
        {/* Right Lantern */}
        <img 
          src={lanternSrc}
          alt=""
          className="absolute -right-20 md:-right-24 lg:-right-28 top-1/2 -translate-y-1/2 w-16 h-20 md:w-20 md:h-24 lg:w-24 lg:h-28 object-contain"
        />
      </div>
    </div>
  );
};

export default TitleWithLanterns;